import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import {PaymentRequestOnlineAttemptModel} from "../../../api/entity/paymentRequestOnlineAttempt.model";

@Injectable({providedIn: 'root'})
export class PaymentRequestOnlineAttemptRepository extends AbstractRepositoryV2<PaymentRequestOnlineAttemptModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('PaymentRequestOnlineAttempt', serviceElementsFactory, injector);
    }
}
